import { createContext, useEffect, useState } from "react";
import { refresh_Token } from "../api/apiManager";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(
    localStorage.getItem("access_token") || ""
  );
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("access_token")
  );

  // Flag to prevent multiple refreshes
  let isRefreshing = false;

  const getRefreshToken = async (yourrefreshToken) => {
    try {
      const response = await refresh_Token(yourrefreshToken);
      if (response?.data?.status === 200) {
        const newToken = response?.data?.result?.token;
        const newExpiryTime = response?.data?.result?.expiration;

        // Save updated token and expiry time
        localStorage.setItem("access_token", newToken);
        localStorage.setItem("token_expiry_time", newExpiryTime);
        setAccessToken(newToken);
        setIsAuthenticated(true);
      }
    } catch (error) {
      console.warn("Failed to refresh token:", error);
      setIsAuthenticated(false);
    }
  };

  const checkTokenExpiry = async () => {
    if (isRefreshing) return;

    const refreshToken = localStorage.getItem("refresh-token");
    const tokenExpiryTime = localStorage.getItem("token_expiry_time");
    const currentTime = new Date();

    if (refreshToken && tokenExpiryTime) {
      if (new Date(tokenExpiryTime) <= currentTime) {
        isRefreshing = true;
        await getRefreshToken(refreshToken);
        isRefreshing = false;
      }
    }
  };

  const handleVisibilityChange = async () => {
    if (!document.hidden) {
      await checkTokenExpiry();
    }
  };

  useEffect(() => {
    const checkInterval = 10 * 1000; // Check every 10 seconds

    // Initial check on mount
    checkTokenExpiry();
    // Set interval to check frequently (instead of every 8 min)
    const interval = setInterval(() => {
      checkTokenExpiry();
    }, checkInterval);

    // Handle visibility change (when tab becomes active)
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <AuthContext.Provider value={{ accessToken, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
